module.exports = __webpack_public_path__ + "static/media/Solero-JPG-Image-4ct-CREAM-Vanilla-Image.9974e2eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/Solero-JPG-Image-4ct-CREAM-Vanilla-Image.jpg
// module id = 186
// module chunks = 0